

// This is handled by an babel plugin that doesn't support ES6. The alternative
// was a plugin that did support ES6 but it resulted in including the entire
var version = '1.0.34';

/** */


/**
 * Format tracker objects
 */
export default function tracker(input) {
  var _ref = input || {},
      trackerData = _ref.tracker;

  return Object.assign({
    name: 'Pulse Node.js SDK',
    type: 'JS',
    eventBuilderVersion: version
  }, trackerData);
}

export function defaultValue() {}